import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ToastController, AlertController, LoadingController, App } from 'ionic-angular';
import { HomePage } from "../home/home";
import { LoginPage } from "../login/login";
import { Configuration } from '../../constants/config';
import { InventarioServiceProvider } from '../../providers/inventario-service/inventario-service';
import { CategoryServiceProvider } from '../../providers/category-service/category-service';
import { SettingsServiceProvider } from '../../providers/settings-service/settings-service';

/**
 * Generated class for the PosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-pos',
    templateUrl: 'pos.html',
})
export class PosPage {
    @ViewChild('inputReg') inputReg;

    canMakePayment = false;
    itemToRegister = null;
    sellItems = [];
    itemList = [];
    categoryList = [];
    total = 0;
    numItems = 0;
    totalItems = 0;
    totalTaxofItems = 0;
    invNumber = "";
    paymentDetails = {};
    applyForDiscount : boolean = false;
    loadingData : boolean = false;
    loader : any = {};

    constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public toastCtrl: ToastController, public loadingCtrl: LoadingController, private app: App, public alertCtrl: AlertController, public inventarioService: InventarioServiceProvider, public categoryService: CategoryServiceProvider, public settingsService: SettingsServiceProvider, public _configuration: Configuration) {
        this.sellItems = this.navParams.data.sellItems;
        this.checkParameters();
        //this.checkTimeOut();
    }

    ionViewWillEnter(){
        this.checkTimeOut();
    }

    checkTimeOut() {
        if (this.navParams.data.tab1Enabled) {
            setTimeout(() => {
                this.checkItems();
            }, 1000);
        }
    }


    /**
     * @Info Check Init Parameters
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    checkParameters(){

        if (!this._configuration.isLogged){
            let data = {IdSettings: 5, token: this._configuration.token};
            this.settingsService.read(data)
                .then(data => {
                    let response : any = data;
                    if (!response.Error){
                        if (response.Success) {
                            this._configuration.defaulTax = response.Content[0].Value;
                            this.canMakePayment = true;
                        }else{
                            let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                            toast.present();
                        }
                    }else{
                        let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                        toast.present();
                    }
                });
        }else{
            this.canMakePayment = true;
        }
    }


    /**
     * @Info Back
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    back(){
        if (this._configuration.isLogged){
            this.app.getRootNav().setRoot(HomePage);
        }else{
            this.app.getRootNav().setRoot(LoginPage);
        }
    }


    /**
     * @Info Add Unlisted Items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-19
     */
    addUnlistedItems(){

        //this.navCtrl.pop();
        //this.navCtrl.setRoot(LoginPage);
        //this.navCtrl.popAll();
        //this.navCtrl.popToRoot();
        //this.navCtrl.setRoot(LoginPage);
        //this.navCtrl.goToRoot(LoginPage)
        //this.navCtrl.push(LoginPage);
        //this.navCtrl.popTo(LoginPage);

        //this.tabRef.select(2);
        //this.navCtrl.parent.select(2);

        if (!this.loadingData){
            if (this.categoryList.length == 0){
                this.loader = this.loadingCtrl.create({
                    content: "Please wait...",
                });
                this.loader.present();
                this.getItemList();
            }else{
                this.showModalSelectItems();
            }
        }
    }


    /**
     * @Info Show Modal to select items
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    showModalSelectItems(){
        const modalData = {categoryList: this.categoryList, itemList: this.itemList};
        let modal = this.modalCtrl.create("ModalSelectItemPage", { data: modalData });
        modal.onDidDismiss(data => {
            if (data){
                if (data.item){
                    this.addItemLoList(data.item, null, true);
                }
            }
        });
        modal.present();
    }


    /**
     * @Info Load item list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getItemList(){
        this.loadingData = true;
        let data = {IdItem: 0, UPC: "0", token: this._configuration.token};
        this.inventarioService.getList(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    this.itemList = response.Content;
                    this.getCategoryList();
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }


    /**
     * @Info Get category List
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getCategoryList(){
        let data = {IdCategory: 0, token: this._configuration.token};
        this.categoryService.getList(data)
            .then(data => {
                this.loader.dismiss();
                let response : any = data;
                this.loadingData = false;
                if (!response.Error){
                    this.categoryList = response.Content;

                    if (this.itemList){
                        if (this.itemList.length > 0) {
                            this.itemList.forEach(item => {
                                let category = this.categoryList.filter(function (e, i) {
                                    return e.IdCategory == item.IdCategory
                                })[0];
                                if (category.items) {
                                    category.items = category.items + 1;
                                } else {
                                    category.items = 1;
                                }
                            });
                        }
                    }

                    this.showModalSelectItems();
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }



    /**
     * @Info Purchase Product
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    purchase(){
        if (this.sellItems.length < 1){
            let toast = this.toastCtrl.create({message: "Scan or select a product before payment",position: 'middle',duration: 3000});
            toast.present();
        }else{
            this.navParams.data.sellItems = this.sellItems;
            this.navParams.data.total = this.total;
            this.navParams.data.tab1Enabled = false;
            this.navParams.data.tab2Enabled = true;
            this.navCtrl.parent.select(1);
        }
    }


    /**
     * @Info Add Quantity to list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    addQuantity(item){
        this.addItemLoList(null, item, true);
    }


    /**
     * @Info Remove Quantity to list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    remQuantity(item){
        let quantity = item.quantity;
        let itemsQuantity = quantity - 1;
        if (itemsQuantity > 0){
            this.addItemLoList(null, item, false);
        }
    }


    /**
     * @Info Delete Item from list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    deleteItem(item){
        const index: number = this.sellItems.indexOf(item);
        if (index !== -1) {
            this.sellItems.splice(index, 1);
            this.getTotals();
        }
    }


    /**
     * @Info Calculate the taxes
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getTax(item, WithDiscount){

        let taxValue = 0;
        if (!this._configuration.isLogged){
            taxValue = this._configuration.defaulTax;
        }else{
            taxValue = this._configuration.CustomerData.Tax;
        }
        let itemTax : number = 0;
        if (item.IsTax){
            if (WithDiscount){
                itemTax = (item.SalePriceDiscount/100)*taxValue;
            }else{
                itemTax = (item.SalePrice/100)*taxValue;
            }
        }
        return itemTax;
    }


    /**
     * @Info Add Items to list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    addItemLoList(item, itemRegistered, adding){

        if (item){
            // Check if the items exist in list
            itemRegistered = this.sellItems.filter(function(e, i){return e.idItem == item.IdItem})[0];
        }

        let totalInventory : number = 0;
        let totalQuantity : number = 1;
        let isInventory : boolean = true;
        let unitPrice : number = 0;
        let taxPrice : number = 0;
        let totalUnitPrice : number = 0;
        let totalPrice : number = 0;
        let totalPriceAllItemsWithoutTax : number = 0;
        let totalTax : number = 0;

        // WD: With Discount
        let unitPriceWD : number = 0;
        let taxPriceWD : number = 0;
        let totalUnitPriceWD : number = 0;
        let totalPriceWD : number = 0;
        let totalPriceAllItemsWithoutTaxWD : number = 0;
        let totalTaxWD : number = 0;
        let itemDiscount : number = 0;
        let totalItemDiscount : number = 0;

        if (itemRegistered){
            // Existing Item
            if (adding){
                totalQuantity = itemRegistered.quantity + 1;
            }else{
                totalQuantity = itemRegistered.quantity - 1;
            }
            isInventory = itemRegistered.isInventory;
            totalInventory = itemRegistered.totalInventory;
            unitPrice = itemRegistered.unitPrice;
            taxPrice = itemRegistered.tax;

            unitPriceWD = itemRegistered.unitPriceWD;
            taxPriceWD = itemRegistered.taxWD;
        }else{
            // New Item
            isInventory = item.IsInventory;
            totalInventory = item.Quantity;
            unitPrice = item.SalePrice;
            taxPrice = this.getTax(item, false);

            unitPriceWD = item.SalePriceDiscount;
            if (unitPriceWD > 0){
                taxPriceWD = this.getTax(item, true);
            }
        }

        if (isInventory && totalQuantity > totalInventory){
            let alert = this.alertCtrl.create({
                title: this._configuration.msgTitles,
                subTitle: "This item can not be added because it exceeds the existence in inventory",
                buttons: ['OK']
            });
            alert.present();
        }else{
            totalUnitPrice = unitPrice + taxPrice;
            totalPriceAllItemsWithoutTax = unitPrice * totalQuantity;
            totalTax = taxPrice * totalQuantity;
            totalPrice = totalUnitPrice * totalQuantity;

            if (unitPriceWD > 0) {
                totalUnitPriceWD = unitPriceWD + taxPriceWD;
                totalPriceAllItemsWithoutTaxWD = unitPriceWD * totalQuantity;
                totalTaxWD = taxPriceWD * totalQuantity;
                totalPriceWD = totalUnitPriceWD * totalQuantity;
                itemDiscount = unitPrice - unitPriceWD;
                totalItemDiscount = itemDiscount * totalQuantity;
            }

            if (itemRegistered){
                itemRegistered.quantity = totalQuantity;
                itemRegistered.totalTax = totalTax;
                itemRegistered.totalPriceAllItemsWithoutTax = totalPriceAllItemsWithoutTax;
                itemRegistered.total = totalPrice;
                itemRegistered.totalTaxWD = totalTaxWD;
                itemRegistered.totalPriceAllItemsWithoutTaxWD = totalPriceAllItemsWithoutTaxWD;
                itemRegistered.totalWD = totalPriceWD;
                itemRegistered.itemDiscount = itemDiscount;
                itemRegistered.totalItemDiscount = totalItemDiscount;
            }else{
                let itemToAdd = {
                    idItem: item.IdItem,
                    name: item.Name,
                    totalInventory: totalInventory,
                    isInventory: isInventory,
                    quantity: totalQuantity,
                    salePrice: item.SalePrice,
                    unitPrice: unitPrice,
                    tax: taxPrice,
                    totalPriceAllItemsWithoutTax: totalPriceAllItemsWithoutTax,
                    totalTax: totalTax,
                    total: totalPrice,
                    salePriceWD: item.SalePriceDiscount,
                    unitPriceWD: unitPriceWD,
                    taxWD: taxPriceWD,
                    totalPriceAllItemsWithoutTaxWD: totalPriceAllItemsWithoutTaxWD,
                    totalTaxWD: totalTaxWD,
                    totalWD: totalPriceWD,
                    itemDiscount: itemDiscount,
                    totalItemDiscount: totalItemDiscount,
                };
                this.sellItems.push(itemToAdd);
            }

            this.getTotals();
        }
    }

    /**
     * @Info Get all totals
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    getTotals(){
        this.numItems = 0;
        this.totalItems = 0;
        this.totalTaxofItems = 0;
        this.total = 0;
        if (this.sellItems.length > 0) {
            this.sellItems.forEach(item => {
                this.numItems = this.numItems + item.quantity;
                this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTax;
                this.totalTaxofItems = this.totalTaxofItems + item.totalTax;
                this.total = this.total + item.total;
            });
        }
    }


    /**
     * @Info Check if are new upc item codes
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    checkItems(){

        //(ionBlur)='checkItems()'

        if (this.itemToRegister){
            let data = {IdItem: 0, UPC: this.itemToRegister, token: this._configuration.token};
            this.inventarioService.getList(data)
                .then(data => {
                    let response : any = data;
                    if (!response.Error){
                        if (response.Success){
                            if (response.Content){
                                this.addItemLoList(response.Content[0], null, true);
                                this.clearAndWait();
                            }else{
                                this.clearAndWait();
                            }
                        }else{
                            this.clearAndWait();
                        }
                    }else{
                        let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                        toast.present();
                    }
                });
        }else{
            this.clearAndWait();
        }
    }

    clearAndWait(){
        this.itemToRegister = null;
        this.inputReg.setFocus();
        this.checkTimeOut();
    }

}


// WEBPACK FOOTER //
// ./src/pages/pos/pos.ts